// Production Lead.Industry restricted picklist — 147 exact values (verified from prod org 2026-06-02).
export const INDUSTRIES = [
  'Automotive - Car Wash',
  'Automotive - Other',
  'Automotive - Parts',
  'Automotive - Repair',
  'Automotive - Sales',
  'Automotive - Towing',
  'Care Providers - Adult Care',
  'Care Providers - Assisted Living',
  'Care Providers - Child Care',
  'Care Providers - Home Health',
  'Care Providers - Other',
  'Construction - Electrician',
  'Construction - Excavation/Site Prep/Foundation',
  'Construction - Framing',
  'Construction - General Contractor (Commercial)',
  'Construction - General Contractor (Residential)',
  'Construction - Heavy and Civil Engineering',
  'Construction - Highway/Street/Bridge',
  'Construction - HVAC/Plumbing',
  'Construction - Other',
  'Construction - Public Utility Construction-Power/Communications',
  'Construction - Public Utility Construction-Water/Sewer',
  'Construction - Roofing',
  'Construction - Siding',
  'Construction - Specialty Trade Contractors (Trim Finishing, Cabinetry, Low Voltage, Drywall, Painting)',
  'Entertainment - Adult',
  'Entertainment - Bar/Nightclub',
  'Entertainment - Other',
  'Entertainment - Sports/Recreation Instruction (Sports, Dance, Gymnastics, Karate, Swim)',
  'Hospitality - Beauty Salon/Spa',
  'Hospitality - Hotel/Motel',
  'Hospitality - Other',
  'Hospitality - Tourism/Travel',
  'Manufacturing - Animal Production',
  'Manufacturing - Brewery',
  'Manufacturing - Cannabis Growers/Sellers (including cannabis only service providers)',
  'Manufacturing - Electrical',
  'Manufacturing - Food',
  'Manufacturing - Furniture',
  'Manufacturing - Other',
  'Manufacturing - Specialty Beverage',
  'Manufacturing - Winery',
  'Medical/Health - Chiropractor',
  'Medical/Health - Dentist',
  'Medical/Health - Lab/Technician',
  'Medical/Health - Medical Billing',
  'Medical/Health - Optometry',
  'Medical/Health - Other',
  'Medical/Health - Pharmacy',
  'Medical/Health - Physicians/Medical Doctor',
  'Medical/Health - Therapists',
  'Medical/Health - Veterinarian',
  'Other - Government/Municipal Agency',
  'Other - Non-Profits',
  'Other - Other',
  'Other - Religious Organizations/Churches',
  'Restaurant - Franchise',
  'Restaurant - Non-Franchise',
  'Restaurant - Other',
  'Restaurant - Specialty/Food Service',
  'Retail Stores - Apparel',
  'Retail Stores - Bakery',
  'Retail Stores - Building/Hardware',
  'Retail Stores - Convenience (Gas)',
  'Retail Stores - Convenience (Non-Gas)',
  'Retail Stores - E-Commerce (No Inventory/Drop Shipping)',
  'Retail Stores - Firearms',
  'Retail Stores - Florist',
  'Retail Stores - Furniture',
  'Retail Stores - Grocery/Food Market',
  'Retail Stores - Liquor Store (Incl. Wine, Beer)',
  'Retail Stores - Mobile Home Dealers',
  'Retail Stores - Other',
  'Retail Stores - Recreational Vehicle Dealers',
  'Retail Stores - Smoke/Tobacco/Vape Shops',
  'Retail Stores - Sporting Goods',
  'Sales/Wholesale Distribution - Broker/Re-Sellers (Coin, Ticket, Pawn Shop)',
  'Sales/Wholesale Distribution - Commercial Equipment Sales/Rental',
  'Sales/Wholesale Distribution - Food Service/Grocery',
  'Sales/Wholesale Distribution - General Sales Organizations',
  'Sales/Wholesale Distribution - Import/Export',
  'Sales/Wholesale Distribution - Industrial Product Sales',
  'Sales/Wholesale Distribution - Medical Equipment Sales',
  'Sales/Wholesale Distribution - Other Sales/Wholesale Distribution',
  'Services (Other) - Aircraft Services',
  'Services (Other) - Cleaning',
  'Services (Other) - Consumer Equipment Rental',
  'Services (Other) - Education/Schooling',
  'Services (Other) - Fitness',
  'Services (Other) - Funeral Services',
  'Services (Other) - Internet/Communications Provider',
  'Services (Other) - Landscaping/Nursery',
  'Services (Other) - Misc. Repair',
  'Services (Other) - Moving/Warehousing/Storage',
  'Services (Other) - Other Services (Other)',
  'Services (Other) - Parking',
  'Services (Other) - Pet Care',
  'Services (Other) - Printing',
  'Services (Other) - Security Services',
  'Services (Professional) - Accounting',
  'Services (Professional) - Advertising',
  'Services (Professional) - Architect/Design',
  'Services (Professional) - Consulting (Business to Business)',
  'Services (Professional) - Consulting (Consumer)',
  'Services (Professional) - Engineering',
  'Services (Professional) - Financial Services (broker/dealers, depository institutions, non-depository credit institutions)',
  'Services (Professional) - Insurance',
  'Services (Professional) - Legal Services',
  'Services (Professional) - Marketing/Research',
  'Services (Professional) - Media Production/Photography/Video',
  'Services (Professional) - Other',
  'Services (Professional) - Property Management',
  'Services (Professional) - Publishing',
  'Services (Professional) - Real Estate',
  'Services (Professional) - Staffing',
  'Services (Professional) - Tax Preparation',
  'Specialized Freight (except Used Goods) Trucking, Long-Distance',
  'Technology Sales & Installation - Audio/Video Equipment',
  'Technology Sales & Installation - Computer Hardware',
  'Technology Sales & Installation - Computer Services',
  'Technology Sales & Installation - Other',
  'Technology Sales & Installation - Security Equipment',
  'Transportation - Delivery, Couriers',
  'Transportation - Other',
  'Transportation - Passenger Transportation',
  'Transportation - Specialty Transportation, Local',
  'Waste/Environmental Services - Agriculture (seasonal and commodity farming)',
  'Waste/Environmental Services - Farming, Animal',
  'Waste/Environmental Services - Farming, Crop',
  'Waste/Environmental Services - Forestry',
  'Waste/Environmental Services - Garbage',
  'Waste/Environmental Services - Logging',
  'Waste/Environmental Services - Oil/Gas Support',
  'Waste/Environmental Services - Oil-Drilling/Fracking',
  'Waste/Environmental Services - Other',
  'Waste/Environmental Services - Recycling',
  'Waste/Environmental Services - Waste Remediation',
  'Cannabis',
  'Warehouse',
  'Mental Health',
  'Psychiatry',
  'Group Home',
  'Nail Salons',
  'Non-Profit',
  'Used Car Sales',
  'Multi-Level Marketing',
  'Oil',
];
